import { ComponentPreloader } from 'components/ComponentPreloader';
import { SSRMediaQuery } from 'components/SSRMediaQuery';
import { BREAKPOINTS, MOBILEBREAKPOINTS } from 'constants/grid';
import HeaderLogo from 'components/HeaderLogo';
import classNames from 'classnames';
import SearchForm from 'components/Search/SearchForm';
import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useMinSpend } from 'hooks/use-min-spend';
import SlideOutNav from '../SlideOutNav';
import { nonDesktopPageLoadPreloadComponents } from '../SiteHeader';
import styles from './index.scss';
import AuthenticationLinks from '../AuthenticationLinks';
import ShoppingSummary from '../ShoppingSummary';
import SlotButton from '../SlotButton';

export const NewMobileHeader = ({ isLoggedIn }) => {
  const [isCheckingLayout, setIsCheckingLayout] = useState(true);
  const { showMinSpend } = useMinSpend();
  const isExtraSmall = useMediaQuery({ maxWidth: MOBILEBREAKPOINTS.xs_sm });
  const placeholder = 'Search groceries...';

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsCheckingLayout(false);
  }, []);

  const MobileSlotButton = (
    <div
      className={classNames(styles.mobileSlot, {
        [styles.hasMinSpend]: showMinSpend,
      })}
    >
      <SlotButton isMobile testId="mobile" textOnly shortTime />
    </div>
  );

  return (
    <SSRMediaQuery maxWidth={BREAKPOINTS.md}>
      <ComponentPreloader components={nonDesktopPageLoadPreloadComponents} />
      <div className={classNames('container-fluid', styles.container)}>
        <div className={classNames(styles.mobileMenu, { [styles.hasMinSpend]: showMinSpend })}>
          <SlideOutNav />
        </div>
        <div className={classNames(styles.mobileLogo, { [styles.hasMinSpend]: showMinSpend })}>
          <HeaderLogo small />
        </div>
        <div
          className={classNames(styles.inner, styles.flexNoShrink, {
            [styles.hasMinSpend]: showMinSpend,
          })}
        >
          <div className={classNames(styles.userLinks, { [styles.hasMinSpend]: showMinSpend })}>
            <AuthenticationLinks
              breakpoint={!isCheckingLayout && !isExtraSmall ? 'mobile' : 'xsMobile'}
              showMinSpend={showMinSpend}
            />
            {isLoggedIn ? MobileSlotButton : null}
            <div className={styles.trolley}>
              <ShoppingSummary showMinSpend={showMinSpend} />
            </div>
          </div>
        </div>
        <div className={styles.mobileSearch}>
          <SearchForm
            placeholder={placeholder}
            className={styles.mobileSearchForm}
            historyClassName={styles.mobileSearchHistoryContainer}
            id="headerSearchForm"
            autocompleteClassName={styles.mobileSearchAutocomplete}
          />
        </div>
      </div>
    </SSRMediaQuery>
  );
};
